<template>
  <div class="huygens-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex> \$2\$ </div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>子波源数量 n</label>
            <span class="val">{{ sourceCount }}</span>
          </div>
          <div class="hud-item orange">
            <label>波速 v</label>
            <span class="val">{{ waveSpeed.toFixed(1) }}</span>
          </div>
          <div class="hud-item green">
             <label>状态</label>
             <span class="val">包络线已形成</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 历史波前 (Previous Wavefront) -->
          <line x1="100" y1="20" x2="100" y2="220" stroke="#334155" stroke-dasharray="2,2" />
          <text x="80" y="215" text-anchor="end" fill="#475569" font-size="9">旧波前 t</text>

          <!-- 原子级子波源 (Secondary Wavelets) -->
          <g v-for="i in sourceCount" :key="'sw'+i">
             <circle :cx="100" :cy="getWaveY(i)" r="2" fill="#0ea5e9" />
             <!-- 半圆子波 (Forward direction only) -->
             <path :d="getWaveletPath(i)" fill="none" stroke="#0ea5e9" :opacity="1 - radius/200" stroke-width="0.5" />
          </g>

          <!-- 宏观包络线 (New Wavefront Envelope) -->
          <line :x1="100 + radius" y1="20" :x2="100 + radius" y2="220" stroke="#fbbf24" stroke-width="4" filter="url(#glow-h)" />
          <text :x="100 + radius + 10" y="215" fill="#fbbf24" font-size="10" font-weight="900">新波面 t + Δt</text>
          
          <defs>
             <filter id="glow-h"><feGaussianBlur stdDeviation="3" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           原理：波前上的每个点都是一个子波源，它们发出的球面子波相切处即是新波前。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节子波离散程度 (源数量)：{{ sourceCount }}</label>
                 <el-slider v-model="sourceCount" :min="3" :max="30" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">推移时间轴 (Δt)：{{ radius }}</label>
                 <el-slider v-model="radius" :min="10" :max="150" size="small"></el-slider>
              </div>
           </div>
        </div>
        
        <!-- 文字对比度高亮加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-refresh"></i></div>
           <div class="text-content">
             <p><strong>实战物理：</strong>惠更斯原理揭开了波动光学最底层的真相。<strong>解惑：</strong>波为什么会转弯？<strong>观察：</strong>调节子波源滑块。你会发现当源足够多时，一个个繁杂的小圈圈“包络”出了一整道平直的新波面。这解释了**球面波、平面波**以及光在遇到障碍物产生**衍射**的几何根源：每个点都在产生新波。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'HuygensPrincipleProViz',
  data() {
    return {
      sourceCount: 12,
      radius: 60,
      waveSpeed: 3.4
    }
  },
  methods: {
    getWaveY(i) {
       return 20 + (i-1) * (200 / (this.sourceCount - 1));
    },
    getWaveletPath(i) {
       const y = this.getWaveY(i);
       // Semicircle arc for forward wavelet
       return `M 100,${y-this.radius} A ${this.radius},${this.radius} 0 0,1 100,${y+this.radius}`;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.huygens-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
